// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Za4Hr","container":"styles_container__560MJ","innerContainer":"styles_innerContainer__pntSI"};